import { useState } from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import { useNavigate} from 'react-router-dom';
import {HomeOutlined, RightOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Checkbox} from 'antd';
import {observer} from 'mobx-react-lite';

import {DOC_OFFER_EN, DOC_OFFER_ES, INDEX} from '../../config/routes';
import {getSession} from '../../hooks/getSession';
import {Store} from '../../model/store/Store';
import {
    createGetMoneyWwOrder,
    createGetMoneyWwOrderVariables
} from '../../shared/graphql/__generated__/createGetMoneyWwOrder';
import {CREATE_ORDER} from '../../shared/graphql/createGetMoneyKzOrder';
import {CurrencyFormat, CurrencySymbol} from '../../shared/helpers/currencies';

import cls from './Payment.module.scss'

export const Payment = observer(() => {

    const {t, i18n} = useTranslation()
    const [check, setCheck] = useState<boolean>(true);

    const navigate = useNavigate()
    const {auth, rate} = useInstance(Store)
    const [createOrder, {loading}] = useMutation<createGetMoneyWwOrder,createGetMoneyWwOrderVariables>(CREATE_ORDER)

    const onCreateOrder = async () => {
        await createOrder({
            variables: {
                session: getSession(),
                token: auth.token!,
                currency: rate.currency,
                data: {},
            },
            onCompleted: (data) => {
                const paymentURL = data.createGetMoneyWwOrder?.data?.attributes?.payment?.data?.attributes?.paymentURL!
                window.location.assign(paymentURL);
            }
        })
    }

    const price = {
        MXN: 64,
        USD: 3.30,
        EUR: 3.40,
        KZT: 1750,
        VND: 98508,
    }

    const lang = i18n.language

    return (
        <div className={cls.wrapper}>
            <h2>{t('Continue filling out the form and add your bank card.')}</h2>
            <div className={cls.row}>
                <div>
                    <div className={'bold'}>{t('"Telelawyer" service')}</div>
                    <div className={'caption'}>
                        {t('Funds will be debited from your card in Kazakhstani tenge at the Central Bank rate on the date of debiting.')}
                    </div>
                    <div className={cls.checkbox}>
                        <Checkbox checked={check} onChange={() => setCheck(!check)}>
                            {t('I agree with')} <a href={lang === 'es' ? DOC_OFFER_ES : DOC_OFFER_EN} target={'_blank'} rel={'noreferrer'}>{t('the terms and conditions of the offer')}</a>
                        </Checkbox>
                    </div>

                </div>
                <div className={cls.sum}>
                    {/*// @ts-ignore*/}
                    {CurrencyFormat(price[rate.currency], 2)} {CurrencySymbol(rate.currency)}
                </div>
            </div>
            <div className={cls.control}>
                <Button size={'large'} icon={<HomeOutlined/>} onClick={() => navigate(INDEX)}/>
                <Button type={'primary'} size={'large'} icon={<RightOutlined/>} onClick={onCreateOrder} loading={loading} disabled={!check}>{t('Next')}</Button>
            </div>
        </div>
    )
})